import React from 'react';
import { AdvantageData } from '../../CaseStudy/types';

import './Advantage.scss';

interface AdvantageProps {
  data: AdvantageData;
  index: number;
}

const Advantage = ({ data, index }: AdvantageProps) => {
  const title = data.serviceList[index].title;
  const answer = data.serviceList[index].answer[0];
  const icon = data.icon[index].image.asset.url;
  const iconAlt = data.icon[index].alt;
  const image = data.image[index].image.asset.url;
  const imageAlt = data.image[index].alt;

  return (
    <div className="advantage">
      <div className="advantage__content">
        <img src={icon} alt={iconAlt} className="advantage__icon" />
        <div className="advantage__description">
          <h3>{title}</h3>
          <p>{answer}</p>
        </div>
      </div>
      <img src={image} alt={imageAlt} className="advantage__img" width="300px" height="300px" />
    </div>
  );
};

export default Advantage;
